<template>
  <div class="container">
    <div class="content section">
      <h1 class="checkout-download__page-title">
        <contentful-text :item="contentfulText('checkout-download-page-title')" />
      </h1>

      <p v-if="!viewModel.Product.IsFulfilled">
        <contentful-text :item="contentfulText('checkout-download-product-not-fulfilled-notification')" />
      </p>

      <div
        v-if="viewModel.Product.IsFulfilled && !viewModel.IsTLHAvailable"
        class="alert__container"
      >
        <contentful-text :item="contentfulText('checkout-download-downloads-not-currently-available')" />
      </div>

      <motion-products
        v-if="hasMotionProducts && !viewModel.GradReelVideoInfo.HasGradReelVideos"
        :products="viewModel.MotionProducts"
        class="checkout-download__section"
      />
      <grad-reel-video
        v-if="viewModel.GradReelVideoInfo.HasGradReelVideos"
        :videoinfo="viewModel.GradReelVideoInfo"
        class="checkout-download__section"
      />
      <send-to-phone
        v-if="showSendToPhoneSection"
        class="checkout-download__section"
      />
      <animated-image
        v-if="hasAnimatedImage"
        class="checkout-download__section"
      />
      <photos
        v-if="!viewModel.HasGradReelPackage"
        class="checkout-download__section"
      />
      <div
        v-if="showSendToPhoneSection"
        class="checkout-download__section"
      >
        <contentful-text :item="contentfulText('checkout-download-fine-print')" />
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedImage from './components/AnimatedImage'
import MotionProducts from './components/MotionProducts'
import Photos from './components/Photos'
import SendToPhone from './components/SendToPhone'
import GradReelVideo from './components/GradReelVideo'

export default {
  name: 'CheckoutDownloadApp',
  components: {
    AnimatedImage,
    SendToPhone,
    MotionProducts,
    Photos,
    GradReelVideo
  },
  computed: {
    pageTitle () {
      return this.$store.state.pageTitle
    },
    viewModel () {
      return this.$store.state.viewModel
    },
    showSendToPhoneSection () {
      return this.viewModel.InstagramDownloadEntitled
    },
    hasAnimatedImage () {
      return this.viewModel.AnimatedImageDownloadEntitled
    },
    hasMotionProducts () {
      return this.$store.getters.hasMotionProducts
    },
    content () {
      return this.viewModel.PageContent
    }
  }
}
</script>

<style lang="scss" scoped>
.checkout-download {
  &__page-title {
    text-align: center;
  }

  &__section {
    margin: 0 0 40px 0;
  }

  @media screen and (min-width: $screen-sm-min) {
    &__page-title {
      text-align: left;
    }
  }
}
</style>

<style lang="scss">
.section-header {
  background: #eee;
  padding: 0.25em;
  text-align: center;

  @media screen and (min-width: $screen-sm-min) {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/App.vue